import {
  ADMIN_AUTH_LOGIN,
  ADMIN_AUTH_LOGOUT,
  ADMIN_AUTH_ERROR,
  ADMIN_AUTH_LOADING,
  ADMIN_FACEBOOK_CONNECT,
  ADMIN_FACEBOOK_DISCONNECT,
} from './actions';

// Initial state
const initialState = {
  isAuthenticated: false,
  adminUser: null,
  loading: false,
  error: null,
  facebookConnected: false,
};

// Check if admin is already logged in from localStorage
try {
  const adminToken = localStorage.getItem('adminToken');
  const adminUser = JSON.parse(localStorage.getItem('adminUser'));

  if (adminToken && adminUser) {
    initialState.isAuthenticated = true;
    initialState.adminUser = adminUser;
  }
} catch (error) {
  // If there's an error parsing the admin user from localStorage, keep the default state
  console.error('Error loading admin auth state from localStorage:', error);
}

// Admin Auth reducer
const adminAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_AUTH_LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        adminUser: action.payload,
        error: null
      };

    case ADMIN_AUTH_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        adminUser: null,
        facebookConnected: false
      };

    case ADMIN_AUTH_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case ADMIN_AUTH_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case ADMIN_FACEBOOK_CONNECT:
      return {
        ...state,
        facebookConnected: true,
        adminUser: {
          ...state.adminUser,
          facebookData: action.payload
        }
      };

    case ADMIN_FACEBOOK_DISCONNECT:
      return {
        ...state,
        facebookConnected: false,
        adminUser: state.adminUser ? {
          ...state.adminUser,
          facebookData: null
        } : null
      };

    default:
      return state;
  }
};

export default adminAuthReducer;
